import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20organized%20product%20showcase%20with%20colorful%20sneakers%20and%20fashion%20items%20neatly%20displayed%20on%20floating%20white%20shelves%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20large%20windows%20with%20soft%20natural%20daylight%2C%20airy%20minimal%20room%2C%20editorial%20lifestyle%20photography%2C%20clean%20modern%20aesthetic%2C%20sophisticated%20product%20presentation&width=1920&height=1080&seq=hero-main-v3&orientation=landscape"
          alt="Sugargoo Spreadsheet - Modern product discovery and shopping guide platform with organized fashion and streetwear categories"
          title="Sugargoo Spreadsheet Product Discovery Platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-24">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-sparkling-line text-sm text-background-50"></i>
          <span className="text-xs font-medium text-background-50 tracking-wide">UPDATED 2026 DATABASE</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          Sugargoo Spreadsheet
          <br />
          <span className="text-primary-300">The Ultimate Product Discovery</span>
          <br />
          <span className="text-lg md:text-2xl lg:text-3xl font-body font-normal text-background-50/80 mt-2 block">
            & Shopping Guide
          </span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Find thousands of organized product recommendations, QC insights, shipping guides, and exclusive shopping resources with the most complete Sugargoo Spreadsheet platform.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2"></i>
            Explore Sugargoo Spreadsheet
          </a>
          <a
            href="#what-is"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-background-50/15 text-background-50 border border-background-50/30 rounded-lg hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-book-open-line mr-2"></i>
            Start Beginner Guide
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 mt-10">
          <span className="flex items-center gap-1.5 text-xs text-background-50/70">
            <i className="ri-check-line text-accent-400 text-sm"></i>
            Updated 2026 Database
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/70">
            <i className="ri-check-line text-accent-400 text-sm"></i>
            Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/70">
            <i className="ri-check-line text-accent-400 text-sm"></i>
            Complete Shopping Guide
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/70">
            <i className="ri-check-line text-accent-400 text-sm"></i>
            Independent Resource
          </span>
        </div>
      </div>
    </section>
  );
}